import { useCallback } from 'react';
import { CreateEntityRolePermissionDto } from '../generated/data-contracts';

/**
 * Hook para transformar datos de roles y permisos antes del envío
 * Asegura que los roles estén en mayúsculas y tengan la estructura correcta
 */
export const useRolePermissionTransform = () => {
  const transformRoles = useCallback((data: any) => {
    if (!data || !data.roles) {
      return data;
    }

    const transformedData = {
      ...data,
      rolePermissions: data.roles
        .filter((rolePermission: any) => 
          rolePermission && 
          rolePermission.role && 
          rolePermission.permissionLevel
        )
        .map((rolePermission: any): CreateEntityRolePermissionDto => ({
          role: rolePermission.role.toString().toUpperCase(),
          permissionLevel: rolePermission.permissionLevel,
        })),
    };

    // Remover roles para evitar confusión con el backend
    delete transformedData.roles;

    console.log('💾 transformRoles - Converted roles to rolePermissions:', transformedData.rolePermissions);

    return transformedData;
  }, []);

  return { transformRoles };
};

/**
 * Hook para transformar datos de edición (incluye rolePermissions)
 * Convierte rolePermissions a roles para compatibilidad con el componente
 */
export const useRolePermissionEditTransform = () => {
  const transformForEdit = useCallback((data: any) => {
    if (!data) return data;

    let transformedData = { ...data };

    // Si tiene rolePermissions, convertir a roles para el formulario
    if (data.rolePermissions && Array.isArray(data.rolePermissions)) {
      transformedData.roles = data.rolePermissions.map((rp: any) => ({
        role: rp.role?.toUpperCase() || '',
        permissionLevel: rp.permissionLevel,
      }));
      
      // Mantener rolePermissions para referencia pero asegurar que roles existe para el componente
      console.log('🔄 transformForEdit - Converted rolePermissions to roles:', transformedData.roles);
    }

    return transformedData;
  }, []);

  const transformForSave = useCallback((data: any) => {
    if (!data || !data.roles) {
      return data;
    }

    // Convertir roles a rolePermissions para el backend
    const transformedData = {
      ...data,
      rolePermissions: data.roles
        .filter((rolePermission: any) => 
          rolePermission && 
          rolePermission.role && 
          rolePermission.permissionLevel
        )
        .map((rolePermission: any): CreateEntityRolePermissionDto => ({
          role: rolePermission.role.toString().toUpperCase(),
          permissionLevel: rolePermission.permissionLevel,
        })),
    };

    // Remover roles para evitar confusión con el backend
    delete transformedData.roles;

    console.log('💾 transformForSave - Converted roles to rolePermissions:', transformedData.rolePermissions);

    return transformedData;
  }, []);

  return { transformForEdit, transformForSave };
};
